import { Card, inlineMediaQueryMixin, token } from "@zillow/constellation";
import PropTypes from "prop-types";
import styled, { css } from "styled-components";
import { ColorCardMixin } from "../../mixins/components/ColorCardMixin.esm.js";
import customPropTypes from "../../utils/custom-prop-types.esm.js";
import { StyledCardImage } from "../CardImage/CardImage.esm.js";
const marginTopBottomCSS = (mediaProps) => css(["margin-top:-", "px;margin-bottom:", "px;"], token(`spacing.${mediaProps.paddingTop}`), token(`spacing.${mediaProps.paddingTop}`));
const marginRightCSS = (mediaProps) => css(["margin-right:-", "px;"], token(`spacing.${mediaProps.paddingRight}`));
const marginLeftCSS = (mediaProps) => css(["margin-left:-", "px;"], token(`spacing.${mediaProps.paddingLeft}`));
const ColorCard = styled(Card).withConfig({
  displayName: "ColorCard",
  componentId: "sc-ux4u3e-0"
})(["display:flex;flex-direction:column;", " ", "{", " ", " ", "}"], ColorCardMixin, StyledCardImage, inlineMediaQueryMixin("paddingTop", marginTopBottomCSS), inlineMediaQueryMixin("paddingLeft", marginLeftCSS), inlineMediaQueryMixin("paddingRight", marginRightCSS));
ColorCard.propTypes = {
  backgroundColor: customPropTypes.inlineMediaQuery(PropTypes.string),
  fontColor: customPropTypes.inlineMediaQuery(PropTypes.string)
};
ColorCard.defaultProps = {};
export {
  ColorCard as default
};
